import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TaxTableColumns = (handleDeleteCharge, toggleChargeModal) => [
  {
    Header: 'Actions',
    headerClassName: 'd-flex justify-content-center align-items-center',
    id: 'actions',
    minWidth: 90,
    resizable: false,
    sortable: false,
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    Cell: ({ index }) => (
      <Fragment>
        <button
          className="border-0 bg-transparent"
          aria-label="Edit"
          onClick={() => toggleChargeModal(index)}
          type="button"
        >
          <FontAwesomeIcon icon="edit" className="color-blue" />
        </button>
        <button
          className="border-0 bg-transparent"
          aria-label="Delete"
          onClick={() => handleDeleteCharge(index)}
          type="button"
        >
          <FontAwesomeIcon icon="trash-alt" className="color-blue" />
        </button>
      </Fragment>
    )
  },
  {
    Header: 'Tax Type',
    headerClassName: 'd-flex align-items-center',
    id: 'taxType',
    className: 'wrap-table-cell',
    minWidth: 180,
    sortable: false,
    accessor: d => d,
    Cell: ({ value: { taxType } }) => {
      if (!taxType) {
        return null;
      }

      return <span>{taxType}</span>;
    }
  },
  {
    Header: 'Rate %',
    headerClassName: 'd-flex align-items-center',
    id: 'ratePct',
    className: 'wrap-table-cell',
    minWidth: 150,
    sortable: false,
    accessor: d => d,
    Cell: ({ value: { taxRate } }) => {
      if (!taxRate) {
        return null;
      }

      return <span>{taxRate}</span>;
    }
  },
  {
    Header: 'Country / Region',
    headerClassName: 'd-flex align-items-center',
    id: 'taxCountryID',
    className: 'wrap-table-cell',
    minWidth: 180,
    sortable: false,
    accessor: d => d,
    Cell: ({ value: { taxCountryID } }) => {
      if (!taxCountryID) {
        return null;
      }

      return <span>{taxCountryID === 'ALL' ? 'All Countries' : taxCountryID}</span>;
    }
  },
  {
    Header: 'State / Province',
    headerClassName: 'd-flex align-items-center',
    id: 'taxState',
    className: 'wrap-table-cell',
    minWidth: 180,
    sortable: false,
    accessor: d => d,
    Cell: ({ value: { taxStateID } }) => {
      if (!taxStateID) {
        return null;
      }

      return <span>{taxStateID === 'ALL' ? 'All States / Provinces' : taxStateID}</span>;
    }
  }
];

export default TaxTableColumns;
